import { useContext } from "react";
import { AppContext } from "./app-context/AppContext";
import { ModalContext } from "./modal-context/ModalContext";
import { SocketContext } from "./socket-provider/ScoketContext";

import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "../App";
import AppProvider from "./app-context/AppProvider";
import ModalProvider from "./modal-context/ModalProvider";
import SocketProvider from "./socket-provider/SocketProvider";

const useApp = () => {
  const value = useContext(AppContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useApp must be wrapped in a <AppProvider />");
    }
  }
  return value;
};

const useModal = () => {
  const value = useContext(ModalContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useModal must be wrapped in a <ModalProvider />");
    }
  }
  return value;
};

const useSocket = () => {
  const value = useContext(SocketContext);
  if (import.meta.env.NODE_ENV !== "production") {
    if (!value) {
      throw new Error("useSocket must be used within a <SocketProvider />");
    }
  }
  return value;
};

const queryClient = new QueryClient();

const Providers = () => {
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <ModalProvider>
            <Router>
              <SocketProvider>
                <App />
              </SocketProvider>
            </Router>
          </ModalProvider>
        </AppProvider>
      </QueryClientProvider>
    </>
  );
};


export { useApp, useModal, useSocket, queryClient, Providers };
